import React from 'react';
import {
    Box,
    ColumnLayout,
    Container,
    Header,
    StatusIndicator,
} from '@amzn/awsui-components-react';
import { VARReportSummary } from 'src/models/reports/ReportGenerationSummary';

const STATUS_TYPE_MAP: Record<string, 'success' | 'error' | 'in-progress'> = {
    'SUCCESS': 'success',
    'FAILED': 'error',
    'PENDING': 'in-progress',
};

export default function VARReportSummarySection({ summary }: { summary?: VARReportSummary }) {
    return (
        <Container header={
            <Header variant="h2"
                description="Variance report comparing expected vs actual TP rates across all CLIs">
                Variance Report Status
            </Header>}>
            {!summary ? (
                <Box textAlign="center" color="inherit"><b>No data available</b><Box variant="p" color="inherit">No variance report data available to display</Box></Box>
            ) : (
            <ColumnLayout columns={3} variant="text-grid">
                <div>
                    <Box variant="awsui-key-label">Status</Box>
                    <StatusIndicator type={STATUS_TYPE_MAP[summary.status] || 'info'}>
                        {summary.status}
                    </StatusIndicator>
                </div>
                <div>
                    <Box variant="awsui-key-label">Report ID</Box>
                    <Box>{summary.reportId || '—'}</Box>
                </div>
                <div>
                    <Box variant="awsui-key-label">Reason Code</Box>
                    <Box>{summary.reasonCode || '—'}</Box>
                </div>
            </ColumnLayout>
            )}
        </Container>
    );
}
